import React from 'react';
import ReactDOM from 'react-dom';

import { Router, Route, Link, browserHistory, IndexRoute } from 'react-router';

import App from './components/App';
import LandingPage from './components/LandingPage/';
import Jobs from './components/Jobs/';
import FourOhFour from './components/404';

import './stylesheets/main.scss';

ReactDOM.render((
    <Router history={browserHistory}>
      <Route path='/' component={ App }>
        <IndexRoute component={ LandingPage }/>
        <Route path='jobs' component={ Jobs }/>
        <Route path="*" component={ FourOhFour }/>
      </Route>
    </Router>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js